import React from "react";
import { Field } from "formik";

function RadioButtons(props) {
  const { label, name, options, ...rest } = props;
  return (
    <div>
      <label>{label}</label>
      <Field name={name}>
        {({ field }) => {
          return options.map((option) => {
            return (
              <React.Fragment key={option.key}>
                <input
                  type="radio"
                  id={option.value}
                  {...field}
                  {...rest}
                  className="mr-1"
                  value={option.value}
                  checked={field.value === option.value}
                />
                <label htmlFor={option.value} className="mr-3">
                  {option.key}
                </label>
                <br />
              </React.Fragment>
            );
          });
        }}
      </Field>
    </div>
  );
}

export default RadioButtons;
